import React, { memo, useState, useRef, useEffect, useCallback } from "react";
import "./PdfMap.css";
import markerImg from "../../../../Assets/Images/orange-home.png";
import "mapbox-gl/dist/mapbox-gl.css";
import Map, { Marker, Source, Layer } from "react-map-gl";
import WebMercatorViewport from "viewport-mercator-project";
import ConstantData from "../../../../Utils/Constant";
import Legend from "../../../Common/Legend";


const pinStyle = {
  cursor: "pointer",
  fill: "#d00",
  stroke: "none",
};
const applyToArray = (func, array) => func.apply(Math, array);
var supplyExtp = [];
var supplyCircles = {}; 
const PdfMap = memo((props) => { 
  const mapRef = useRef();
  const [marketData1, setMarketData1] = useState({});
  const [viewport, setViewPort] = useState({
    width: "100%",
    height: "100vh",
    longitude: -97.86589,
    latitude: 37.70959,
    zoom: 3.5,
    cursor: "pointer",
  });
  const [marketInfo, setMarketInfo] = useState({});
  const [profile, setProfile] = useState({ showProfile: false });
  const [profileInfo, setProfileInfo] = useState({});

  //change center point on lat lng  changed
  const handleViewportChange = useCallback((newViewport) =>
    setViewPort(newViewport)
  );
  // //get interactive map data
     useEffect(()=>{
        if (props && props.data) {
            setViewPort({
              ...viewport,
              latitude: props.data.latitude,
              longitude: props.data.longitude,
            });
            getSupplyCircle(
                props.data.latitude,
                props.data.longitude,
                props.data.supplyradius,
                props.data.demandradius
            );
            setMarketInfo(props.data);
            const newParksData = [];
            for(let feature of props.marketPois.features){
              feature.data.typeid = feature.typeid
              newParksData.push(feature.data); 
            }
            newParksData.sort((a, b) => b.features.length - a.features.length);
            setMarketData1(newParksData);
          }
     },[props && props.data ])

  //calculate bounding box value for circle default adjustment
  const getBoundingValues = (points) => {
    if (points) {
      const pointsLong = points.geometry.coordinates.map((point) => point[0]);
      const pointsLat = points.geometry.coordinates.map((point) => point[1]);
      const cornersLongLat = [
        [applyToArray(Math.min, pointsLong), applyToArray(Math.min, pointsLat)],
        [applyToArray(Math.max, pointsLong), applyToArray(Math.max, pointsLat)],
      ];
      const viewport = new WebMercatorViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      }).fitBounds(cornersLongLat, {
        padding: { top: 100, bottom: 100, left: 100, right: 100 },
      });
      const { longitude, latitude, zoom } = viewport;
      setViewPort({
        ...viewport,
        latitude: latitude,
        longitude: longitude,
        zoom: zoom - 1,
      });
    }
  };

  //draw circle
  const getSupplyCircle = (sLat, sLng,  radius, demandRadi) => {
    supplyCircles = {};
    let radiusCal = radius;
    let lat = sLat;
    let lng = sLng;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    // find the raidus in lat/lon
    var rlat = (radiusCal / earthsradius) * r2d;
    var rlng = rlat / Math.cos(lat * d2r);

    supplyExtp = [];
    if (dir === 1) {
      var start = 0;
      var end = points + 1;
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      let ey = lng + rlng * Math.cos(theta);
      let ex = lat + rlat * Math.sin(theta);
      supplyExtp.push([ey, ex]);
    }
    supplyCircles = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: supplyExtp,
      },
    };
    if (radius > demandRadi || radius === demandRadi) {
      getBoundingValues(supplyCircles);
    }
  };

  //get profile details for selected pins
  const getcoordinates = (event) => {
    if (event.features[0] && event.features[0].layer.type === "circle") {
      setProfileInfo({
        ...profileInfo,
        profileInfo: event.features[0].properties,
      });
      setProfile({ ...profile, showProfile: true });
    }
  };

  
  return (
    <div>
        <div className="address">      
            { marketInfo && marketInfo.supplyradius  ? marketInfo.supplyradius + " " + "miles radius around" : ""}{" "}
            { props && props.address ? props.address : ""}
        </div>
      <div className="interactive-map">
        <Map
          {...viewport}
          ref={mapRef}
          preserveDrawingBuffer={true}
          onClick={getcoordinates}
          onViewportChange={handleViewportChange}
          getCursor={(e) => "pointer"}
          mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
          mapStyle="mapbox://styles/mapbox/streets-v11"
        >
          <Source id="route1" type="geojson" data={supplyCircles} />
          <Layer
            type="line"
            source="route1"
            layout={{
              "line-join": "round",
              "line-cap": "round",
            }}
            paint={{
              "line-color": "#000000",
              "line-width": 2,
            }}
          />
          <Layer
            type="line"
            source="route2"
            layout={{
              "line-join": "round",
              "line-cap": "round",
            }}
            paint={{
              "line-color": "#000000",
              "line-width": 2,
            }}
          />

            {marketData1 && marketData1.length > 0 && marketData1.map((data, index) => {
              return (
                <Source key={index} id={`source-${index}`} type="geojson" data={data}>
                  <Layer
                    id={`layer-${index}`}
                    type="circle"
                    source={`source-${index}`}                            
                    paint={{
                      "circle-radius": 4,
                      "circle-color": ["get", "colorcode"],
                    }}
                  />
                </Source>
              );
            })}

          {marketInfo && marketInfo.latitude && marketInfo.longitude ? (
            <Marker
              longitude={marketInfo.longitude}
              latitude={marketInfo.latitude}
            >
              <img
                src={markerImg}
                alt="Marker Pin"
                height={20}
                viewBox="0 0 24 24"
                style={{
                  ...pinStyle,
                  transform: `translate(${-10 / 2}px,${-10}px)`,
                }}
              ></img>
            </Marker>
          ) : (
            ""
          )}

          <Legend legendType ={ConstantData.legendDefaultKeys} /> 

        </Map>
      </div>
    </div>
  );
});

export default PdfMap;
